import { Icon, Modal, Text } from 'components/common'
import { colors } from 'lib/colors'

interface AllowDuplicateModalProps {
  errorMessages: string[]
  onCancel: () => void
  onOk: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
  okText: string
  open: boolean
  loading: boolean
}

const AllowDuplicateModal = ({
  errorMessages,
  open,
  onCancel,
  okText,
  onOk,
  loading,
}: AllowDuplicateModalProps): JSX.Element => {
  return (
    <Modal
      open={open}
      title={
        <div className="flex items-center text-3xl space-x-2">
          <Icon.InfoCircleTwoTone twoToneColor={colors.DODGERBLUE} />
          <Text strong>他の顧客情報と重複する項目があります</Text>
        </div>
      }
      okText={okText}
      cancelText="キャンセル"
      onCancel={onCancel}
      onOk={onOk}
      confirmLoading={loading}
    >
      <p className="mb-4">
        以下の項目は、既に登録されている他の顧客情報と重複しています。
        <br />
        重複を許可して
        {okText}する場合は「{okText}
        」を、許可しない場合は「キャンセル」をクリックしてください。
      </p>
      <div className="bg-gray-100 p-4">
        <ul className="space-y-2 font-bold pl-8 list-disc m-0">
          {errorMessages?.map((message, index) => (
            <li key={message + index}>{message}</li>
          ))}
        </ul>
      </div>
    </Modal>
  )
}

export default AllowDuplicateModal
